import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const isAuth = localStorage.getItem('isAuth') === 'true';
  const jwtToken = localStorage.getItem('access_token');

  const [isAuthenticated, setIsAuthenticated] = useState(isAuth);
  const [token, setToken] = useState(jwtToken);

  const login = (token) => {
    setIsAuthenticated(true);
    setToken(token);
    localStorage.setItem('isAuth', true);
    localStorage.setItem('access_token', token);
  }

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.setItem('isAuth', false);
    localStorage.removeItem('access_token');
  }

  useEffect(() => {
      if (token) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } else {
          delete axios.defaults.headers.common['Authorization'];
      }
  }, [token]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
